import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useVerifyEmail from 'hooks/auth/useVerifyEmail';
import LoadingOverlay from 'components/common/LoadingOverlay';

const VerifyEmail = () => {
  const { token } = useParams<{ token: string }>();

  const handleConfirmEmail = useVerifyEmail();

  useEffect(() => {
    handleConfirmEmail(token);
  }, [handleConfirmEmail, token]);

  return <LoadingOverlay />;
};

export default VerifyEmail;
